<template>
  <geo-json-source :data="props.data" :source-id="sourceId">
    <layer-group :layers="layers" />
  </geo-json-source>
</template>

<script setup lang="ts">
import { LayerSpecification } from 'mapbox-gl'
import GeoJsonSource from '@/components/field-view-next/mapbox/GeoJsonSource.vue'
import LayerGroup from '@/components/field-view-next/mapbox/LayerGroup.vue'

const props = defineProps<{
  data: object
}>()

const sourceId = 'single-point'

const layers: LayerSpecification[] = [
  {
    id: 'single-point-pin',
    source: sourceId,
    type: 'symbol',
    layout: {
      'icon-allow-overlap': true,
      'icon-size': 1,
      'icon-image': 'owned__#0650b2__mdi-map-marker',
      'icon-anchor': 'bottom',
    },
  },
]
</script>
